import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const Brand = () => {
  return (
    <SettingsMetaData propertyName={"VehicleBrand"} viewPropertyName={"Vehicle Brand"}/>
  );
};

export default Brand;
